<template>
<v-app id="inspire">
  <div class="wrap-payment-show">
    <!-- Header -->
    <div class="sr-pl-show-top-header">
      <v-layout>
        <p class="header-p header-inv-num">
          <span class="headline">Payment
            <span v-if="amount">of ${{ parseFloat(amount).toFixed(2) }}</span>
            <span v-if="tip_amount" class="text-body-2">{{ ` Includes $${parseFloat(tip_amount).toFixed(2)}` }} in Tips!</span>
          </span>
        </p>
        <v-spacer></v-spacer>
        <v-btn class="header-btn-back mt-0 mb-3 mr-0" @click="$router.go(-1)">
          <v-icon class="header-btn-back-icon">navigate_before</v-icon>
          Back
        </v-btn>
      </v-layout>
      <v-layout class="mb-6">
        <v-flex xs6>
          <div v-if="payment_status" class="header-p">
            <v-icon v-if="payment_type === 'credit_card'" class="mr-2" style="font-size: 22px;">credit_card</v-icon>
            <v-icon v-else class="mr-2" style="font-size: 22px;">credit_card</v-icon>
            <div :class="`payment-status-${payment_status}`"
              style="font-size: 13px; vertical-align: text-top; display: inline;"
            >
              <span class="payment-status-text">
                <span>{{ titleCase(payment_status) }}</span>
              </span>
            </div>
          </div>
          <!-- <div class="mt-1">
            <v-btn class="ma-0" icon><v-icon>print</v-icon></v-btn> 
            <v-btn class="ma-0" icon><v-icon>email</v-icon></v-btn> 
          </div> -->
        </v-flex>
        <v-flex class="d-flex xs6">
          <v-layout class="wrap">
            <v-spacer></v-spacer>
            <v-menu v-if="['succeeded', 'partially_refunded'].includes(payment_status)" offset-y bottom left class="d-inline-flex">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" class="mr-0 mt-0 px-4">
                  Actions <v-icon right>keyboard_arrow_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item 
                  v-if="['succeeded', 'partially_refunded'].includes(payment_status)"
                  @click="vEmit({ name: 'RefundPayment', data: payment_details_items[0] })"
                >
                  <v-list-item-title>
                    <v-icon color="#607d8b" class="mr-2">replay</v-icon>
                    Refund
                  </v-list-item-title>
                </v-list-item>
                <v-list-item 
                  v-if="['succeeded', 'partially_refunded'].includes(payment_status) && payment_type === 'check'" 
                  @click="vEmit({ name: 'DeletePayment', data: payment_details_items[0] })"
                >
                  <v-list-item-title>
                    <v-icon color="error" class="mr-2">delete</v-icon>
                    Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-layout>

    </div>

    <!-- Info -->
    <v-card v-if="payment_status === 'failed'">
      <v-data-table
        :headers="info_headers"
        :items="info_items"
        hide-default-footer
        class="elevation-1 sr-pl-sh-table"
        colwidth-1='30px'
        :loading="loading"
        loader-height="2"
        mobile-breakpoint="100">
        <template v-slot:item="{item}">
          <tr>
            <td>Failure Info</td>
            <td>{{ item.details }}</td>
          </tr>                                          
        </template>
      </v-data-table>
    </v-card>

    <!-- Payment Details -->
    <v-card>
      <v-data-table
        :headers="payment_details_headers"
        :items="payment_details_items"
        hide-default-footer
        class="elevation-1 sr-pl-sh-table"
        colwidth-1='30px'
        :loading="loading"
        loader-height="2"
        mobile-breakpoint="100">
        <template v-slot:item="{item}">
          <tr>
            <td>Client</td>
            <td>
              <template v-if="!no_data.includes(item.commercial_client_id)">
                <router-link
                  v-if="!no_data.includes(item.commercial_location) && !no_data.includes(item.commercial_location_id)"
                  :to="`/commercial_client/${item.commercial_client_id}/show?commercial_location_id=${item.commercial_location_id}`"
                  class="remove-underline">{{ `${item.commercial_client} - ${item.commercial_location}`}}
                </router-link>
                <router-link
                  v-else
                  :to="`/commercial_client/${item.commercial_client_id}/show`"
                  class="remove-underline">{{ item.commercial_client }}
                </router-link>
              </template>
              <router-link
                v-else
                :to="`/client/${item.client_id}/show`"
                class="remove-underline">{{item.client_name}}
              </router-link>
            </td>
            <td>Payment Method</td>
            <td>{{titleCase(item.type)}}</td>
          </tr>          
          <tr>
            <td>Payment ID</td>
            <td>{{item.reference_number}}</td>
            <td>Status</td>           
            <td :class="`payment-status-${item.status}`">
              <div class="payment-status-text">
                <span>{{ titleCase(item.status)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>Payment Date</td>
            <td>{{ item.date }}</td>
            <template v-if="item.status === 'partially_refunded'">
              <td>Refunded Amount</td>
              <td>${{ parseFloat(item.amount_refunded).toFixed(2) }}</td>
            </template>
            <template v-else>
              <td></td>
              <td></td>
            </template>
          </tr>                                      
        </template>
      </v-data-table>
    </v-card>

    <v-card v-if="!editing">               
      <v-data-table
        :headers="description_headers"
        :items="payment_invoices"
        :loading="loading"
        loader-height="2"
        class="elevation-0 table-org sr-pl-sh-table"
        hide-default-footer
        mobile-breakpoint="100"
        >
        <template v-slot:item="{item}">
          <tr>
            <td><router-link v-bind:to="'/invoice/' + item.invoice_id" class="remove-underline">{{ item.invoice_number }}</router-link></td>
            <td>{{ timeFormat(item.created_at) }}</td>
            <td>${{ withCommas(parseFloat(item.invoice_total).toFixed(2)) }}</td>
            <td>${{ withCommas(parseFloat(item.tip_amount).toFixed(2)) }}</td>
            <td>${{ withCommas(parseFloat(item.remaining).toFixed(2)) }}</td>
            <td>${{ withCommas(parseFloat(item.amount).toFixed(2)) }}</td>
          </tr>           
        </template>
      </v-data-table>
      <template v-if="!loading && payment_type === 'check'">
        <v-divider></v-divider>
        <v-layout class="px-6 py-4">
          <v-spacer></v-spacer>
          <v-btn @click="editPayment" color="primary" class="my-0">Edit</v-btn>
        </v-layout>
      </template>
    </v-card>
    <update-payment @done="loadAfterUpdate" @close="editing = false"></update-payment>

    <!-- Card Info table -->
    <v-card v-if="credit_card[0] !== null">
      <v-data-table
        :headers="card_info_headers"
        :items="credit_card"
        hide-default-footer
        class="elevation-1 sr-pl-sh-table"
        colwidth-1='30px'
        :loading="loading"
        loader-height="2"
        mobile-breakpoint="100">
        <template v-slot:item="{item}">
          <tr>
            <td>Name on Card</td>
            <td>
              <span v-if="!no_data.includes(item.name)">{{item.name}}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>Type</td>
            <td>
              <span v-if="!no_data.includes(item.brand)">{{item.brand}}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>          
          <tr>
            <td>Number</td>
            <td>
              <span v-if="!no_data.includes(item.last4)">{{ `**** ${item.last4}` }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>Expires</td>
            <td>
              <span v-if="!no_data.includes(item.exp_month) && !no_data.includes(item.exp_year)">{{`${item.exp_month}/${item.exp_year}`}}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>                                     
        </template>
      </v-data-table>
    </v-card>

      <refund-payment @done="getPayments"></refund-payment>
      <delete-payment @done="$router.go(-1)"></delete-payment>
    </div>
  </v-app>
</template>

<script>
  import ApiService from "@/common/api.service"
  import DeletePayment from "./DeletePayment"
  import RefundPayment from "./RefundPayment"
  import UpdatePayment from "./UpdatePayment"
  import { mapActions } from 'vuex';

  export default {
    name: "PaymentShow",
    components: {
      DeletePayment,
      RefundPayment,
      UpdatePayment
    },
    data() {
      return {
        invoiceNumber: '',         
        invoiceSubType:'',        
        loading: false,
        no_data: [null, '', undefined, 'null'],
        info_headers: [
          {
            text: 'Info',
            align: 'left',
            sortable: false,
            value: 'info',
            width: '20%'
          },
          {
            sortable: false,
          }
        ],         
        payment_details_headers: [
          {
            text: 'Payment Details',
            align: 'left',
            sortable: false,
            value: 'Summary',
            width: '20%'
          },
          {
            sortable: false,
          },
          {
            sortable: false,
            width: '20%'
          },
          {
            sortable: false            
          }          
        ],
        description_headers: [
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'invoice_number',            
          },
          {
            text: 'Due Date',            
            sortable: false,
            value: 'date',            
          },
          {
            text: 'Original Amount',            
            sortable: false,
            value: 'amount',           
          },
          {
            text: 'Tip',            
            sortable: false,
            value: 'tip_amount',           
          },
          {
            text: 'Open Balance',            
            sortable: false,
            value: 'amount', 
          },
          {
            text: 'Payment',            
            sortable: false,
            value: 'amount'
          }        
        ],
        card_info_headers: [
          {
            text: 'Card Info',
            align: 'left',
            sortable: false,
            value: 'Summary',
            width: '20%'
          },
          {
            sortable: false,
          },
          {
            sortable: false,
            width: '20%'
          },
          {
            sortable: false            
          }          
        ],
        editing: false,
        payment_details_items:[],
        payment_invoices:[],
        info_items: [],
        amount: null,
        tip_amount: null,
        payment_status: null,
        payment_type: null,
        credit_card: [null],
        serverValidation: true,
        serverValidationMessage: '',
        server_errors: {}
      }
    },    
    beforeMount(){
      this.getPayments()
    },      
    methods: {
    ...mapActions(['vEmit']),
    getPayments(id = this.$route.params.id) {
      this.loading = true;
      let body = {
        payment_id: id
      }
      ApiService.get('/payment/show', body)
        .then(response => {
          this.loading = false
          this.info_items = [{ details: response.data.payment.failure_message }]
          this.payment_details_items = [response.data.payment]
          this.payment_invoices = response.data.payment_invoices
          this.credit_card = [response.data.credit_card]
          this.amount = response.data.payment.amount
          this.tip_amount = response.data.payment.tip_amount
          this.payment_status = response.data.payment.status
          this.payment_type = response.data.payment.type
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    editPayment() {
      this.editing = true
      this.vEmit({
        name: 'UpdatePayment',
        data: { payment: _.cloneDeep(this.payment_details_items[0]), payment_invoices: _.cloneDeep(this.payment_invoices) }
      })
    }, 
    loadAfterUpdate() {
      this.editing = false
      this.getPayments()
    }, 
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    //Remove underscores from response
    removeUnderScore(str){            
      for(let i in str){
        str = str.replace('_', ' ');                
      }
      return str = str.replace(/\w\S*/g, function(txt) {
        return txt.toUpperCase();
      });
    },
    //Make a firts character capital of string from response
    makeCapitalFirstLetter(str){
      str = str.toLowerCase();
      return str.charAt(0).toUpperCase() + str.slice(1)      
    },
    //Go to Individual Invoice Edit
    goToInvoiceEdit(id){
      this.$router.push(`/invoice/${id}/edit`)
    },
    displayCountry(i) {
      let output = i
      if (['US', 'Us', 'us'].includes(i)) { output = 'United States' }
      return output
    },
    withCommas(i) {
      var parts = i.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    titleCase(str){
        return _.startCase(str.replace(/_/g, ' '));
    },
    resetServerValidation() {
        this.serverValidation = true
        this.serverValidationMessage = 'Oops something went wrong...'
        this.server_errors = {}
    },
    timeFormat(date) {
        return moment(date).format('MMM DD, YYYY HH:mm');
    }
  }      
}
</script>

<style>
  /*Header*/
  .wrap-payment-show .header-search-single {
    padding-bottom: 25px;
  }
  .wrap-payment-show .name-plan{
    font-size: x-large;
    font-weight: 500;
  }

  .wrap-payment-show .header-p{
    font-size: small;
  }

  .wrap-payment-show .header-p:first-of-type{
    font-size: medium;
    margin-bottom: 0px;
  }

  .wrap-payment-show .header-inv-num{
    display: inline-block;
  }

  .wrap-payment-show .header-btn-back{
    float: right;
    box-shadow: none !important;
    background-color: #f8f9fa !important;
    text-transform: none; 
    font-weight: 400;   
  }
  .wrap-payment-show .header-btn-back:focus{
    outline: none;
  }
  .wrap-payment-show .header-btn-back-icon{
    margin: 2px -5px 0px 0px;
  }
      
  /*Tables*/
  .wrap-payment-show .sr-pl-sh-table{
    margin:40px 0px 0px 0px;
  }
  .wrap-payment-show .sr-pl-sh-table:first-child {
    margin: 20px 0px 0px;
  }
  /* .sr-pl-sh-table thead tr:first-of-type{
    background-color: darkgray;    
  } */
  .sr-pl-sh-table thead tr:first-of-type th{
    color: #000;
    font-size: 15px;
    font-weight: initial;
  }
  .sr-pl-sh-table-pricing .pricing-plan-td-text{
    margin: 20px 0px 5px 0px;
    color: dodgerblue;
    font-weight: 500;
    display: inline-block; 
  }

  .sr-pl-sh-plans-date{
    float: right;
    margin: 20px 0px 5px 0px;
  }

  .wrap-payment-show .inv-total-text, .inv-total-text{
    font-size: larger;
    font-weight: 600;
  }
  
  .payment-status-failed{
    color: #FF5252;
    min-width: 200px;
  }
  .payment-status-succeeded{
    color: #4CAF50;
  }
  .payment-status-refunded, .payment-status-partially_refunded {
    color: #91a5af;
  }

  .wrap-payment-show .payment-status-text{
    /* border: solid 1px;
    text-align: center;    
    max-width: 170px;
    padding: 0 15px; */
    display: inline-block;
    text-transform: uppercase;
  }
  .inv-edit-icon{
    vertical-align: bottom;
  }
  #inv-status-td{
    min-width: 200px;
  }

   /* Make DIV sections to look like table rows */
  .inv-desc-table-style{
    background-color: white !important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  
  /*Invoice total section*/
  .inv-desc-total {
    text-align: right;
    font-size: 14px;
  }

  .inv-desc-amount-titles {
    display: inline-block;
    padding-right: 50px;
    font-size: 14px;
  }

  .inv-desc-amount-values {
    display: inline-block;
    text-align: left;
    width: 208px;
    padding: 24px;
  }

  .inv-edit-table-desc>.v-table__overflow {    
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    }

  .wrap-inv-description{
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden
  } 
  .memo {
    padding: 15px 24px;
    font-size: 13px;
  }
    
</style>


  
    
 


